import { Component, computed, inject } from '@angular/core';
import { materialModules } from 'src/shared/material.module';
import { globalWindow } from 'src/shared/window-globals';
import { EvaSidebarService } from '../eva-sidebar.service';
import { EvaPageContextService } from '../shared/services/eva-page-context.service';

const maxLengthBothExpanded = 16;
const maxLengthBothCollapsed = 8;
const maxLengthSingleExpanded = 33;
const maxLengthSingleCollapsed = 18;

@Component({
  selector: 'ez-eva-context',
  imports: [
    materialModules,
  ],
  templateUrl: './eva-context.component.html',
  styleUrl: './eva-context.component.scss',
})
export class EvaContextComponent {
  readonly #pageContextService = inject(EvaPageContextService);
  readonly #evaSidebarService = inject(EvaSidebarService);

  protected readonly anchor = this.#pageContextService.activeAnchor;
  protected readonly isVisible = this.#pageContextService.isAnchorVisible;

  readonly #showsBoth = computed(() => {
    const active = this.anchor();
    return !!(active?.applicantId && active.applicantName && active.policyId);
  });

  readonly #maxLength = computed(() => {
    const expanded = this.#evaSidebarService.isExpanded();
    return this.#showsBoth()
      ? expanded ? maxLengthBothExpanded : maxLengthBothCollapsed
      : expanded ? maxLengthSingleExpanded : maxLengthSingleCollapsed;
  });

  protected readonly decodedApplicantName = computed(() =>
    this.#decodeAmpersand(this.anchor()?.applicantName ?? null));

  protected readonly decodedPolicyNumber = computed(() =>
    this.#decodeAmpersand(this.anchor()?.policyNumber ?? null));

  protected readonly truncatedApplicantName = computed(() => this.#truncate(this.decodedApplicantName()));

  protected readonly truncatedPolicyNumber = computed(() => this.#truncate(this.decodedPolicyNumber()));

  protected readonly navigateToPolicy = computed(() => {
    const policyId = this.anchor()?.policyId;
    return policyId ? globalWindow.UrlResolver.ApplicantPortal(`policy/${policyId}/summary/index`) : '';
  });

  protected clear(): void {
    this.#pageContextService.clearAnchor();
  }

  protected navigateToApplicant(applicantId: number): void {
    this.#pageContextService.pinCurrentAnchorThroughNavigation();

    if (globalWindow.fiveComponentRef) {
      globalWindow.fiveComponentRef.routerLink(`/account/${applicantId}/overview`);
    } else {
      window.location.href = globalWindow.UrlResolver.MrFive(`account/${applicantId}/overview`);
    }
  }

  #decodeAmpersand(text: string | null): string | null {
    return text ? text.replace(/&(?:amp;)+/g, '&') : null;
  }

  #truncate(text: string | null): string {
    if (!text) {
      return '';
    }
    const maxLength = this.#maxLength();
    return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
  }
}
